<div class="nav-sublist-title">
  <!--  TODO: svg check - size="2px -->
  <wchfs-icon class="icon" size="2px" svgIcon="wchfs:form_arrow_down_ico"></wchfs-icon>
  <ng-content></ng-content>
</div>
